import React, { Component } from 'react';
import './AccountPage.css';
import { withFirebase } from "../Firebase";
import { withRouter } from "react-router-dom";
import * as ROUTES from '../../constants/routes';
import userProfilImage from '../assets/icon_user_profile.svg';
import BasicCard from "../Card/BasicCard";
import planet_pairs_little from "../assets/planet_pairs_little.svg";
import planet_responsable_medium from "../assets/planet_responsable_medium.svg";
import planet_little_equipe from "../assets/planet_little_equipe.svg";
import TrelloConnection from "../Account/TestTrelloPage";
import uuid from 'uuid/v1';
import SnackBar from '../SnackBar/SnackBar';
import imageCompression from 'browser-image-compression';
import Tooltip from '@material-ui/core/Tooltip';

class AccountPage extends Component {
  render() {
    return (
      <>
        <AccountProfileB />
      </>);
  }
}

const INITIAL_STATE = {
  users: null,
  companies: null,
  current_user: null,
  image_user: null,
  lastname: '',
  firstname: '',
  position: '',
  email: '',
  newPassword: '',
  currentPassword: '',
  current_uid: null,
  password_snack: false
};

class AccountProfile extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE, capsules: [], trello_token: "" };
  }

  componentDidMount() {
    document.body.style.background = "#F8F9FB";
    let uid;
    if (this.props.firebase.auth.currentUser) {
      uid = this.props.firebase.auth.currentUser.uid
      this.setState({ current_uid: uid });
      this.props.firebase.db
        .collection("capsules")
        .where("creator", "==", uid)
        .get()
        .then(querysnapshot => {
          let capsules = querysnapshot.docs.map(capsule => {
            return {
              id: capsule.id,
              ...capsule.data()
            }
          }
          )
          this.setState({ capsules: capsules });

        }).catch((error) => {
          console.error(error);
        })
      this.props.firebase.db
        .collection("users")
        .doc(uid)
        .get()
        .then((doc) => {
          if (doc.exists) {
            const cu = doc.data();
            this.setState({
              current_user: cu, image_user: doc.data().image_url_profile, lastname: doc.data().lastname,
              firstname: doc.data().firstname,
              email: doc.data().email, position: doc.data().position
            });
          }
        })
        .catch((error) => {
          console.error("Error getting document:", error);
        });
    }


  }

  doSignOut = () => {
    this.props.firebase.auth.signOut()
    window.location.replace('/login')
  }

  updateProfileImg = async e => {
    e.persist()
    if (e.target.files[0]) {

      let imageUuid = uuid();
      const current_image = await imageCompression(e.target.files[0], {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true
      });
      await this.props.firebase.storage.ref(`images/${imageUuid}`).put(current_image)
      let url = await this.props.firebase.storage.ref('images').child(imageUuid).getDownloadURL()
      await this.props.firebase.db.collection('users').doc(this.props.firebase.auth.currentUser.uid).update({ image_url_profile: url })
      this.setState({ image_user: url });
    }
  }


  pictureProfileAccount = () => {
    const {
      image_user
    } = this.state;
    return (
      <div className="container">
        <div className="row">
          <div className="col"></div>
          <div className="col text-center">
            <label htmlFor="profile-import" className="import">
              <img className="picture-profile mt-5 cursor-pointer" src={image_user !== null ? image_user : userProfilImage} alt="Profile" onError={this.props.firebase.profileImgError}></img>
            </label>
            <input onChange={this.updateProfileImg} hidden={true} id="profile-import" className="import" type="file" accept="image/*" />
            <h1 onClick={this.doSignOut} className="deconnection cursor-pointer">Se déconnecter</h1>
            <TrelloConnection />
          </div>
          <div className="col"></div>
        </div>
      </div>
    )
  }

  myRoutes = (route) => {
    switch (route) {
      case 'peers':
        return this.props.history.push(ROUTES.PEERS);
      case 'team':
        return this.props.history.push(ROUTES.TEAM);
      case 'manager':
        return this.props.history.push(ROUTES.MANAGER);
      default:
        return null;
    }
  }

  constellationAccount = () => {
    const {
      image_user
    } = this.state;
    return (
      <div>
        <h1 className="info-title">Ma constellation</h1>
        <div className="mb-5"></div>
        {/* <div className="d-flex">
          <img alt="add" className="img-add" src={addTeamMate} />
          <h1 className="cursor-pointer invitation-mate mb-5">inviter un équiper</h1>
        </div> */}
        <div className="oval">
          <img className="profile-planet" src={image_user !== null ? image_user : userProfilImage} alt="Profile" onError={this.props.firebase.profileImgError}></img>
          <h2 onClick={() => this.myRoutes('peers')} className="pair-text cursor-pointer">Pair</h2>
          <Tooltip title="Voir mes pairs" aria-label="pairs">
            <img onClick={() => this.myRoutes('peers')} className="pair-planet cursor-pointer" src={planet_pairs_little} alt="logo"></img>
          </Tooltip>
          <h2 onClick={() => this.myRoutes('manager')} className="responsable-text cursor-pointer">Responsable</h2>
          <Tooltip title="Voir mon responsable" aria-label="responsable">
            <img onClick={() => this.myRoutes('manager')} className="responsable-planet cursor-pointer" src={planet_responsable_medium} alt="logo"></img>
          </Tooltip>
          <h2 onClick={() => this.myRoutes('team')} className="equipe-text cursor-pointer">Equipe</h2>
          <Tooltip title="Voir mon équipe" aria-label="equipe">
            <img onClick={() => this.myRoutes('team')} className="equipe-planet cursor-pointer" src={planet_little_equipe} alt="logo"></img>
          </Tooltip>
        </div>
      </div>
    )
  }

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  }

  onSubmitUserInformations = event => {
    event.preventDefault();
    const { firstname, lastname, email, position, current_uid } = this.state;
    this.props.firebase.user(current_uid).set({ firstname: firstname, lastname: lastname, email: email, position: position }, { merge: true })
      .catch(errors => {
        console.error(errors);
      })
  }




  infoAccount = () => {
    const {
      lastname,
      firstname,
      position,
      email,
    } = this.state;
    return (
      <div>
        <form onSubmit={this.onSubmitUserInformations}>
          <h1 className="info-title">Mes informations</h1>
          <div className="label-profile">
            <label>Nom</label>
            <div>
              <input
                className="custom-input-account"
                name="lastname"
                type="text"
                onChange={this.onChange}
                placeholder="Nom"
                value={lastname}
              />
            </div>
          </div>
          <div className="label-profile">
            <label>Prénom</label>
            <div>
              <input
                className="custom-input-account"
                name="firstname"
                type="text"
                onChange={this.onChange}
                placeholder="Prénom"
                value={firstname}
              />
            </div>
          </div>
          <div className="label-profile">
            <label>Poste occupé</label>
            <div>
              <input required
                className="custom-input-account"
                name="position"
                type="text"
                onChange={this.onChange}
                placeholder="Poste occupé"
                value={position}
              />
            </div>
          </div>
          <div className="label-profile">
            <label>Mail</label>
            <div>
              <input
                className="custom-input-account"
                name="mail"
                onChange={this.onChange}
                type="text"
                placeholder="Mail"
                value={email}
              />
            </div>
          </div>
          <h1 onClick={this.emailNewPassword} className="text-right change-pass cursor-pointer">Changer de mot de passe</h1>
          <div className="btn-save-container text-right">
            <button className="btn-save" type="submit">Enregistrer</button>
          </div>
        </form>
        <SnackBar
          open={this.state.password_snack}
          handleClose={this.closePasswordSnack}
          messageSnackBar={'Un mail vous a été envoyé'}
          remove={true}
        />
      </div>
    );
  }

  closePasswordSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ password_snack: false });
  }

  emailNewPassword = () => {
    this.props.firebase
      .doPasswordReset(this.state.current_user.email)
      .then(() => {
        this.setState({ password_snack: true })
      })
      .catch(error => {
        this.setState({ error });
      });
  }

  onOpenCapsule = (capsule) => {
    this.props.history.push(`/capsule/${capsule}`);
  }

  myCapsules = () => {
    const { capsules } = this.state;
    return (
      <div>
        <h1 className="text-center title-my-cps mb-5">Mes capsules créées</h1>
        {capsules.length > 3 ? <div className="d-flex  basic-card-scrolling-wrapper">
          {capsules.map((capsule, index) => <div className="mr-5 mb-5" key={index}>
            <BasicCard
              capsule={capsule}
              cardIndex={index + 1}
              direction={"down"}
              onOpenCapsule={this.onOpenCapsule}
              active={false}
            />
          </div>)}
        </div> : <div className="d-flex justify-content-center basic-card-scrolling-wrapper">
            {capsules.map((capsule, index) => <div className="mr-5 mb-5" key={index}>
              <BasicCard
                capsule={capsule}
                cardIndex={index + 1}
                direction={"down"}
                onOpenCapsule={this.onOpenCapsule}
                active={false}
              />
            </div>)}
          </div>}
      </div>
    )
  }

  render() {
    return (
      <div className="">
        <div className="account-background">
          <div className="mb-5" >
            {this.pictureProfileAccount()}
          </div>
          <div className="container pb-5">
            <div className="row">
              <div className={window.innerWidth > 768 ? "col position-block" : "col account-info-mobile"}>
                {this.infoAccount()}
              </div>
              <div className="col position-block">
                {this.constellationAccount()}
              </div>
            </div>
          </div>
        </div>

        <div className="account-background mt-3 pt-4 mb-3">
          {this.myCapsules()}
        </div>
      </div>
    )
  }
}

const AccountProfileB = withRouter(withFirebase(AccountProfile));
export { AccountProfileB }
export default AccountPage;
